import { render, staticRenderFns } from "./service-card.vue?vue&type=template&id=117daaf1&scoped=true&"
import script from "./service-card.vue?vue&type=script&lang=js&"
export * from "./service-card.vue?vue&type=script&lang=js&"
import style0 from "./service-card.vue?vue&type=style&index=0&id=117daaf1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117daaf1",
  null
  
)

export default component.exports